(function() {
    var m = angular.module('utils');

    m.directive('region', ['regions', function(regions) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ngModel) {

                var element = $(elm);

                function fillRegions() {
                    element.html('');
                    for (var i in regions) {
                        element.append($('<option>').val(regions[i].id).html(regions[i].name));
                    }
                    element.val(ngModel.$viewValue);
                }

                var watcher = scope.$watch(function() {
                    return ngModel;
                }, function() {
                    fillRegions();
                    watcher(); // remove watcher
                });
            }
        };
    }]);
})();
